import { USER_KEY } from "../constants";

export default () => {
  const { placeName } = JSON.parse(localStorage.getItem(USER_KEY) || "{}");
  return placeName;
};
